<template>
  <div class="text-center mt-5">
    <h1>404 - Page Not Found</h1>
    <p>You will be redirected to the homepage shortly.</p>

    <!-- Go to Home Button -->
    <router-link to="/" class="btn btn-primary mt-3">
      Go to Homepage
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    setTimeout(() => {
      if (this.$route.path !== '/') {
        this.$router.replace('/').catch(() => {});
      }
    }, 3000);
  }
};
</script>